import React, { useState } from "react";

const PrepareLoanDisbursement = ({
  id_R,
  closePrepareLoanDisbursementModal,
  isPrepareLoanDisbursementModalOpen,
  convertDateOfBirth,
  convertLoanDates,
  customerDetails,
  loanType,
  mpesaNumber,
  loanCustomer,
  guarantors,
  navigateToCustomer,
  setSelectedGuarantor,
  openGuarantorDetailsOpen,
  openChooseDisbursementMethodOpen,
  declineDisbursment,
  approvals,
}) => {
  const handleViewEye = () => {
    closePrepareLoanDisbursementModal();
    openGuarantorDetailsOpen();
  };
  const handleDisburseLoan = () => {
    if (activeTab === "tab1") {
      setActiveTab("tab2");
    } else if (activeTab === "tab2") {
      setActiveTab("tab3");
    } else if (activeTab === "tab3") {
      setActiveTab("tab4");
    } else if (activeTab === "tab4") {
      closePrepareLoanDisbursementModal();
      openChooseDisbursementMethodOpen();
    }
  };

  const getLoanProductName = (productId) => {
    if (productId === "Flash_loan") {
      return "Flash Loan";
    } else if (productId === "Emergency_loan") {
      return "Emergency Loan";
    } else if (productId === "Guarantor_loan") {
      return "Normal Loan";
    } else if (productId === "Development_loan") {
      return "Development Loan";
    } else if (productId === "Jijenge_loan") {
      return "Jijenge Loan";
    } else {
      return "Unknown Loan Type";
    }
  };

  const savingsAccount = customerDetails?.data?.accounts?.find(
    (account) => account.product_id === "eab1ba28-4867-4762-a3aa-ab5d6e557482",
  );
  const savingsBalance = savingsAccount ? savingsAccount.balance : "N/A";

  const sharesAccount = customerDetails?.data?.accounts?.find(
    (account) => account.product_id === "1f30885f-15d3-47b3-91e4-dda7013a9fcc",
  );
  const sharesBalance = sharesAccount ? sharesAccount.balance : "N/A";

  const [activeTab, setActiveTab] = useState("tab1");

  return (
    <>
      <div
        id={id_R}
        className={`${
          isPrepareLoanDisbursementModalOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-10 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center min-h-screen w-[60%] max-w-[100%] h-full md:h-auto">
          <div className="relative bg-white shadow w-[100%] max-w-[90%] h-[90vh] px-4 flex rounded-sm flex-col">
            {/* Modal Header */}
            <div className="justify-end rounded-t flex items-end">
              <button
                onClick={closePrepareLoanDisbursementModal}
                type="button"
                className="bg-transparent rounded-lg text-sm p-2.5 ml-auto inline-flex items-center"
                data-modal-toggle={id_R}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.84 12L5.7 8.9L3.9 12H0.2L3.88 6.3L0.1 0.839999H3.94L6.08 3.92L7.88 0.839999H11.58L7.84 6.46L11.68 12H7.84Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>

            {/* Modal Content */}
            <div className="flex flex-col flex-1 overflow-y-auto">
              <h1 className="text-start text-2xl font-bold text-black mb-2">
                Prepare for Loan Disbursement
              </h1>
              <p>
                Confirm the loan details and ensure all disbursement
                requirements are met before proceeding. This step
              </p>
              <p>
                finalizes the loan process and releases funds to the borrower.
              </p>

              {/* Tabs */}
              <div className="flex items-center justify-between mx-[10px] w-[50vw]">
                <button
                  className="flex-1 text-center mt-1.5 h-[39px]"
                  onClick={() => setActiveTab("tab1")}
                >
                  <p
                    className={`text-[#000] text-[16px] ${
                      activeTab === "tab1" ? "font-medium" : ""
                    }`}
                  >
                    LOAN DETAILS
                  </p>
                  <div
                    className={`w-full h-[4px] mt-1.5 ${
                      activeTab === "tab1" ? "bg-[#005C53]" : "bg-transparent"
                    }`}
                  />
                </button>

                <button
                  className="flex-1 text-center mt-1.5 h-[39px]"
                  onClick={() => setActiveTab("tab2")}
                >
                  <p
                    className={`text-[#000] text-[16px] ${
                      activeTab === "tab2" ? "font-medium" : ""
                    }`}
                  >
                    MEMBER’S DETAILS
                  </p>
                  <div
                    className={`w-full h-[4px] mt-1.5 ${
                      activeTab === "tab2" ? "bg-[#005C53]" : "bg-transparent"
                    }`}
                  />
                </button>

                <button
                  className="flex-1 text-center mt-1.5 h-[39px]"
                  onClick={() => setActiveTab("tab3")}
                >
                  <p
                    className={`text-[#000] text-[16px] ${
                      activeTab === "tab3" ? "font-medium" : ""
                    }`}
                  >
                    GUARANTORSHIP
                  </p>
                  <div
                    className={`w-full h-[4px] mt-1.5 ${
                      activeTab === "tab3" ? "bg-[#005C53]" : "bg-transparent"
                    }`}
                  />
                </button>

                <button
                  className="flex-1 text-center mt-1.5 h-[39px]"
                  onClick={() => setActiveTab("tab4")}
                >
                  <p
                    className={`text-[#000] text-[16px] ${
                      activeTab === "tab4" ? "font-medium" : ""
                    }`}
                  >
                    APPROVAL DETAILS
                  </p>
                  <div
                    className={`w-full h-[4px] mt-1.5 ${
                      activeTab === "tab4" ? "bg-[#005C53]" : "bg-transparent"
                    }`}
                  />
                </button>
              </div>
              {/* Tab Content */}
              <div className="flex-1 overflow-y-auto">
                {activeTab === "tab1" && loanCustomer && (
                  <div>
                    <div className="flex flex-col items-start bg-[#F0FFFE] mt-8 w-[95%] mx-[20px] rounded-[5px] border border-[#ECECEC] px-4 py-4">
                      <div className="flex mt-4">
                        <div className="w-[30vw]">
                          <p className="text-[#000000] text-[12px] font-[400]">
                            Loan Product
                          </p>
                          <p className="text-[#000000] text-[12px] mt-6 font-[400]">
                            Loan Principal
                          </p>
                        </div>
                        <div className="w-[20vw]">
                          <p className="text-[#000000] text-[12px] font-[500]">
                            {loanCustomer &&
                              getLoanProductName(loanCustomer.loan_product_id)}
                          </p>
                          <p className="text-[#000000] text-[12px] mt-6 font-[500]">
                            {Number(
                              loanCustomer?.loan_amount || "0.00",
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                        </div>
                      </div>

                      <div className="flex mt-6">
                        <div className="w-[30vw]">
                          <p className="text-[#000000] text-[12px] font-[400]">
                            Interest Rate
                          </p>
                          <p className="text-[#000000] text-[12px] mt-6 font-[400]">
                            Repayment Amount
                          </p>
                        </div>
                        <div className="w-[20vw]">
                          <p className="text-[#000000] text-[12px] font-[500]">
                            {loanCustomer?.loan_interest_per != null
                              ? `${loanCustomer?.loan_interest_per}% ${
                                  loanCustomer?.interest_key || ""
                                }`
                              : "Not available"}
                          </p>
                          <p className="text-[#000000] text-[12px] mt-6 font-[500]">
                            {Number(
                              loanCustomer?.loan_balance || "0.00",
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                        </div>
                      </div>

                      <div className="flex mt-8">
                        <div className="w-[30vw]">
                          <p className="text-[#000000] text-[12px] font-[400]">
                            Loan Duration
                          </p>
                        </div>
                        <div className="w-[20vw]">
                          <p className="text-[#000000] text-[12px] font-[500]">
                            {loanCustomer?.loan_period != null
                              ? `${Number(
                                  loanCustomer.loan_period,
                                ).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })} ${
                                  Number(loanCustomer.loan_period) === 1
                                    ? "Month"
                                    : "Months"
                                }`
                              : "N/A"}
                            -
                            {loanCustomer?.loan_due_date === "N/A"
                              ? "N/A"
                              : loanCustomer?.loan_due_date != null
                                ? convertLoanDates(loanCustomer?.loan_due_date)
                                : "Not available"}
                          </p>
                        </div>
                      </div>

                      <div className="flex mt-8">
                        <div className="w-[30vw]">
                          <p className="text-[#000000] text-[12px] font-[400]">
                            Outstanding Balance
                          </p>
                        </div>
                        <div className="w-[20vw]">
                          <p className="text-[#000000] text-[12px] font-[500]">
                            {Number(
                              loanCustomer?.loan_balance || "0.00",
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "tab2" && (
                  <div>
                    {loanCustomer?.customer?.public_id ? (
                      <div className="mx-5">
                        <div className="flex items-center w-full mt-5">
                          <div className="flex flex-col w-[50%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              Member ID
                            </p>
                            <p
                              onClick={() =>
                                navigateToCustomer(loanCustomer?.customer?.id)
                              }
                              className="text-[#06B217] text-[15px] cursor-pointer"
                            >
                              #{loanCustomer?.customer?.public_id}
                            </p>
                          </div>
                          <div className="flex flex-col w-[50%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              Savings Amount
                            </p>
                            <p className="text-[#4F4F4F] text-[15px] font-[400]">
                              {savingsBalance}
                            </p>
                          </div>
                          <div className="flex flex-col w-[55%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              Shares Amount
                            </p>
                            <p className="text-[#4F4F4F] text-[15px] font-[400]">
                              {sharesBalance}
                            </p>
                          </div>
                        </div>

                        <div className="flex items-center w-full mt-8">
                          <div className="flex flex-col w-[50%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              First Name
                            </p>
                            <p className="text-[#4F4F4F] text-[15px] font-[400]">
                              {loanCustomer?.customer?.firstname || "N/A"}
                            </p>
                          </div>
                          <div className="flex flex-col w-[50%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              Middle Name
                            </p>
                            <p className="text-[#4F4F4F] text-[15px] font-[400]">
                              {loanCustomer?.customer?.middlename
                                ? loanCustomer?.customer?.middlename
                                : "N/A"}
                            </p>
                          </div>
                          <div className="flex flex-col w-[55%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              Last Name
                            </p>
                            <p className="text-[#4F4F4F] text-[15px] font-[400]">
                              {loanCustomer?.customer?.lastname || "N/A"}
                            </p>
                          </div>
                        </div>

                        <div className="flex items-center w-full mt-8">
                          <div className="flex flex-col w-[50%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              Date of Birth
                            </p>
                            <p className="text-[#4F4F4F] text-[15px] font-[400]">
                              {convertDateOfBirth(
                                loanCustomer?.customer?.dob,
                              ) || "N/A"}
                            </p>
                          </div>
                          <div className="flex flex-col w-[50%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              Phone Number
                            </p>
                            <p className="text-[#4F4F4F] text-[15px] font-[400]">
                              {mpesaNumber}
                            </p>
                          </div>
                          <div className="flex flex-col w-[55%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              Email
                            </p>
                            <p className="text-[#4F4F4F] text-[15px] font-[400]">
                              {loanCustomer?.customer?.email || "N/A"}
                            </p>
                          </div>
                        </div>

                        <div className="flex items-center w-full mt-8">
                          <div className="flex flex-col w-[50%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              KRA PIN
                            </p>
                            <p className="text-[#4F4F4F] text-[15px] font-[400]">
                              {loanCustomer?.customer?.kraPin || "N/A"}
                            </p>
                          </div>
                          <div className="flex flex-col w-[50%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              Employment Type
                            </p>
                            <p className="text-[#4F4F4F] text-[15px] font-[400]">
                              {loanCustomer?.customer?.employment_type || "N/A"}
                            </p>
                          </div>

                          <div className="flex flex-col w-[55%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              Job Title
                            </p>
                            <p className="text-[#4F4F4F] text-[15px] font-[400]">
                              {loanCustomer?.customer?.occupation || "N/A"}
                            </p>
                          </div>
                        </div>

                        <div className="flex items-center w-full mt-8">
                          <div className="flex flex-col w-[55%]">
                            <p className="text-[#000000] text-[16px] font-[500]">
                              Monthly Income
                            </p>
                            <p className="text-[#4F4F4F] text-[15px] font-[400]">
                              KES{" "}
                              {Number(
                                loanCustomer?.customer?.income_range || "0.00",
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <p className="text-[#005C53] text-[15px]">
                        Member details not available.
                      </p>
                    )}
                  </div>
                )}

                {activeTab === "tab3" && (
                  <div className="mx-5">
                    <div className="h-[54vh] overflow-y-auto mt-4">
                      {loanType === "Guarantor_loan" ||
                      loanType === "Development_loan" ||
                      loanType === "Jijenge_loan" ? (
                        <>
                          <div className="h-[44px] w-full text-[14px] font-[400] px-[20px] flex items-center mt-[10px] bg-[#F0FFFE]">
                            <p className="w-[20%] !m-0 !p-0">Member ID</p>
                            <p className="w-[25%] !m-0 !p-0">Name</p>
                            <p className="w-[22%] !m-0 !p-0">Phone number</p>
                            <p className="w-[22%] !m-0 !p-0">G. Amount</p>
                            <p className="w-[22%] !m-0 !p-0">Status</p>
                            <p className="w-[15%] !m-0 !p-0">Actions</p>
                          </div>

                          {guarantors?.length > 0 ? (
                            guarantors?.map((guarantor) => (
                              <div
                                key={guarantor?.id}
                                className="h-[44px] w-full px-[20px] flex items-center mt-[10px]"
                              >
                                <p
                                  onClick={() => {
                                    setSelectedGuarantor(guarantor);
                                    handleViewEye();
                                  }}
                                  className="w-[20%] text-[#06B217] cursor-pointer font-[500] text-[14px] underline decoration-solid underline-offset-[1px] decoration-[1px]"
                                >
                                  {guarantor?.memberID}
                                </p>

                                <p className="w-[25%]">
                                  {guarantor?.name
                                    ?.split(" ")
                                    ?.map(
                                      (nam) =>
                                        nam?.charAt(0)?.toUpperCase() +
                                        nam?.slice(1)?.toLowerCase(),
                                    )
                                    ?.join(" ")}
                                </p>
                                <p className="w-[22%]">
                                  {guarantor?.phoneNumber}
                                </p>
                                <p className="w-[22%]">
                                  KES{" "}
                                  {Number(
                                    guarantor?.amountGuaranteed || 0,
                                  ).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </p>

                                <div className="w-[22%] flex items-center gap-[2px]">
                                  {guarantor?.status === "accepted" && (
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8 0C8.73438 0 9.44271 0.09375 10.125 0.28125C10.8073 0.46875 11.4427 0.739583 12.0312 1.09375C12.6198 1.44792 13.1589 1.86458 13.6484 2.34375C14.138 2.82292 14.5573 3.36198 14.9062 3.96094C15.2552 4.5599 15.5234 5.19792 15.7109 5.875C15.8984 6.55208 15.9948 7.26042 16 8C16 8.73438 15.9062 9.44271 15.7188 10.125C15.5312 10.8073 15.2604 11.4427 14.9062 12.0312C14.5521 12.6198 14.1354 13.1589 13.6562 13.6484C13.1771 14.138 12.638 14.5573 12.0391 14.9062C11.4401 15.2552 10.8021 15.5234 10.125 15.7109C9.44792 15.8984 8.73958 15.9948 8 16C7.26562 16 6.55729 15.9062 5.875 15.7188C5.19271 15.5312 4.55729 15.2604 3.96875 14.9062C3.38021 14.5521 2.84115 14.1354 2.35156 13.6562C1.86198 13.1771 1.44271 12.638 1.09375 12.0391C0.744792 11.4401 0.476562 10.8021 0.289062 10.125C0.101562 9.44792 0.00520833 8.73958 0 8C0 7.26562 0.09375 6.55729 0.28125 5.875C0.46875 5.19271 0.739583 4.55729 1.09375 3.96875C1.44792 3.38021 1.86458 2.84115 2.34375 2.35156C2.82292 1.86198 3.36198 1.44271 3.96094 1.09375C4.5599 0.744792 5.19792 0.476562 5.875 0.289062C6.55208 0.101562 7.26042 0.00520833 8 0ZM12.7109 5.35156L11.6484 4.28906L6.5 9.4375L4.35156 7.28906L3.28906 8.35156L6.5 11.5625L12.7109 5.35156Z"
                                        fill="#0C722F"
                                      />
                                    </svg>
                                  )}
                                  {guarantor?.status === "pending" && (
                                    <svg
                                      width="15"
                                      height="15"
                                      viewBox="0 0 15 15"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M3.75 8.625C4.0625 8.625 4.32825 8.5155 4.54725 8.2965C4.76625 8.0775 4.8755 7.812 4.875 7.5C4.875 7.1875 4.7655 6.92175 4.5465 6.70275C4.3275 6.48375 4.062 6.3745 3.75 6.375C3.4375 6.375 3.17175 6.4845 2.95275 6.7035C2.73375 6.9225 2.6245 7.188 2.625 7.5C2.625 7.8125 2.7345 8.07825 2.9535 8.29725C3.1725 8.51625 3.438 8.6255 3.75 8.625ZM7.5 8.625C7.8125 8.625 8.07825 8.5155 8.29725 8.2965C8.51625 8.0775 8.6255 7.812 8.625 7.5C8.625 7.1875 8.5155 6.92175 8.2965 6.70275C8.0775 6.48375 7.812 6.3745 7.5 6.375C7.1875 6.375 6.92175 6.4845 6.70275 6.7035C6.48375 6.9225 6.3745 7.188 6.375 7.5C6.375 7.8125 6.4845 8.07825 6.7035 8.29725C6.9225 8.51625 7.188 8.6255 7.5 8.625ZM11.25 8.625C11.5625 8.625 11.8282 8.5155 12.0472 8.2965C12.2662 8.0775 12.3755 7.812 12.375 7.5C12.375 7.1875 12.2655 6.92175 12.0465 6.70275C11.8275 6.48375 11.562 6.3745 11.25 6.375C10.9375 6.375 10.6717 6.4845 10.4527 6.7035C10.2337 6.9225 10.1245 7.188 10.125 7.5C10.125 7.8125 10.2345 8.07825 10.4535 8.29725C10.6725 8.51625 10.938 8.6255 11.25 8.625ZM7.5 15C6.4625 15 5.4875 14.803 4.575 14.409C3.6625 14.015 2.86875 13.4807 2.19375 12.8062C1.51875 12.1312 0.9845 11.3375 0.591 10.425C0.1975 9.5125 0.0005 8.5375 0 7.5C0 6.4625 0.197 5.4875 0.591 4.575C0.985 3.6625 1.51925 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.9845 4.575 0.591C5.4875 0.1975 6.4625 0.0005 7.5 0C8.5375 0 9.5125 0.197 10.425 0.591C11.3375 0.985 12.1312 1.51925 12.8062 2.19375C13.4812 2.86875 14.0157 3.6625 14.4097 4.575C14.8037 5.4875 15.0005 6.4625 15 7.5C15 8.5375 14.803 9.5125 14.409 10.425C14.015 11.3375 13.4807 12.1312 12.8062 12.8062C12.1312 13.4812 11.3375 14.0157 10.425 14.4097C9.5125 14.8037 8.5375 15.0005 7.5 15Z"
                                        fill="#554D4D"
                                      />
                                    </svg>
                                  )}
                                  {guarantor?.status === "rejected" && (
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <mask
                                        id="mask0_2968_2005"
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="18"
                                        height="18"
                                      >
                                        <path
                                          d="M0 0.325878C0 0.160192 0.134315 0.0258789 0.3 0.0258789H17.7C17.8657 0.0258789 18 0.160194 18 0.325879V17.6746C18 17.8403 17.8657 17.9746 17.7 17.9746H0.3C0.134314 17.9746 0 17.8403 0 17.6746V0.325878Z"
                                          fill="white"
                                        />
                                      </mask>
                                      <g mask="url(#mask0_2968_2005)">
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M18 0.325878C18 0.160192 17.8657 0.0258789 17.7 0.0258789H0.3C0.134314 0.0258789 0 0.160194 0 0.325879V17.6746C0 17.8403 0.134315 17.9746 0.3 17.9746H17.7C17.8657 17.9746 18 17.8403 18 17.6746V0.325878ZM13.326 4.99169C13.3918 4.91664 13.442 4.82921 13.4734 4.73455C13.5049 4.63989 13.5171 4.53992 13.5092 4.4405C13.5013 4.34109 13.4736 4.24425 13.4277 4.15568C13.3817 4.0671 13.3185 3.98859 13.2417 3.92475C13.1648 3.8609 13.076 3.81303 12.9803 3.78394C12.8847 3.75485 12.7841 3.74512 12.6847 3.75534C12.5852 3.76556 12.4888 3.79552 12.4011 3.84345C12.3134 3.89137 12.2362 3.95631 12.174 4.03443L9.2302 7.55664C9.11028 7.70013 8.88973 7.70012 8.76981 7.55663L5.82638 4.03443C5.76384 3.95743 5.68658 3.89359 5.59909 3.84661C5.5116 3.79964 5.41562 3.77047 5.31673 3.7608C5.21784 3.75113 5.11801 3.76116 5.02303 3.79029C4.92806 3.81942 4.83984 3.86708 4.76349 3.9305C4.68715 3.99392 4.6242 4.07183 4.57831 4.15971C4.53242 4.2476 4.5045 4.3437 4.49617 4.44243C4.48785 4.54117 4.49928 4.64056 4.52981 4.73486C4.56034 4.82915 4.60935 4.91645 4.674 4.99169L7.86311 8.80786C7.95618 8.91923 7.95618 9.08125 7.86311 9.19261L4.674 13.0088C4.60815 13.0838 4.55802 13.1713 4.52656 13.2659C4.4951 13.3606 4.48294 13.4606 4.4908 13.56C4.49865 13.6594 4.52637 13.7562 4.57232 13.8448C4.61826 13.9334 4.68151 14.0119 4.75834 14.0757C4.83517 14.1396 4.92402 14.1874 5.01968 14.2165C5.11533 14.2456 5.21586 14.2554 5.31534 14.2451C5.41482 14.2349 5.51124 14.205 5.59894 14.157C5.68664 14.1091 5.76384 14.0442 5.826 13.966L8.76981 10.4438C8.88973 10.3003 9.11027 10.3003 9.23019 10.4438L12.174 13.966C12.2362 14.0442 12.3134 14.1091 12.4011 14.157C12.4888 14.205 12.5852 14.2349 12.6847 14.2451C12.7841 14.2554 12.8847 14.2456 12.9803 14.2165C13.076 14.1874 13.1648 14.1396 13.2417 14.0757C13.3185 14.0119 13.3817 13.9334 13.4277 13.8448C13.4736 13.7562 13.5013 13.6594 13.5092 13.56C13.5171 13.4606 13.5049 13.3606 13.4734 13.2659C13.442 13.1713 13.3918 13.0838 13.326 13.0088L10.1369 9.19261C10.0438 9.08125 10.0438 8.91923 10.1369 8.80786L13.326 4.99169Z"
                                          fill="#FF5757"
                                        />
                                      </g>
                                    </svg>
                                  )}
                                  <p className="text-[#005C53] ml-2">
                                    {guarantor?.status
                                      ? guarantor?.status
                                          ?.charAt(0)
                                          ?.toUpperCase() +
                                        guarantor?.status
                                          ?.slice(1)
                                          ?.toLowerCase()
                                      : "N/A"}
                                  </p>
                                </div>
                                <div
                                  onClick={() => {
                                    setSelectedGuarantor(guarantor);
                                    handleViewEye();
                                  }}
                                  className="w-[15%] flex items-center cursor-pointer"
                                >
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                                      fill="#06B217"
                                    />
                                    <path
                                      d="M23.2047 11.745C22.3226 9.46324 20.7912 7.48996 18.7998 6.06906C16.8084 4.64817 14.4443 3.84193 11.9997 3.75C9.55507 3.84193 7.19097 4.64817 5.19958 6.06906C3.20819 7.48996 1.6768 9.46324 0.794681 11.745C0.735106 11.9098 0.735106 12.0902 0.794681 12.255C1.6768 14.5368 3.20819 16.51 5.19958 17.9309C7.19097 19.3518 9.55507 20.1581 11.9997 20.25C14.4443 20.1581 16.8084 19.3518 18.7998 17.9309C20.7912 16.51 22.3226 14.5368 23.2047 12.255C23.2643 12.0902 23.2643 11.9098 23.2047 11.745ZM11.9997 16.875C11.0355 16.875 10.093 16.5891 9.29128 16.0534C8.48959 15.5177 7.86475 14.7564 7.49577 13.8656C7.12679 12.9748 7.03025 11.9946 7.21835 11.0489C7.40646 10.1033 7.87075 9.23464 8.55254 8.55285C9.23432 7.87107 10.103 7.40677 11.0486 7.21867C11.9943 7.03057 12.9745 7.12711 13.8653 7.49609C14.7561 7.86506 15.5174 8.48991 16.0531 9.2916C16.5888 10.0933 16.8747 11.0358 16.8747 12C16.8727 13.2923 16.3584 14.5311 15.4446 15.445C14.5308 16.3588 13.292 16.873 11.9997 16.875Z"
                                      fill="#06B217"
                                    />
                                  </svg>
                                </div>
                              </div>
                            ))
                          ) : (
                            <p className="text-center text-gray-700 mt-4 text-lg font-bold flex justify-center items-center h-32">
                              You have no guarantors.
                            </p>
                          )}
                        </>
                      ) : (
                        <div className="flex flex-col justify-end items-center h-[42vh]">
                          <svg
                            width="136"
                            height="136"
                            viewBox="0 0 136 136"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M53.4344 14.3176L71.6092 23.6649L91.131 17.6156L99.0454 36.4586L117.888 44.373L111.839 63.8948L121.186 82.0696L104.004 93.1358L99.4819 113.067L79.2062 110.499L62.9307 122.861L49.0489 107.861L28.6354 106.869L27.643 86.4551L12.6432 72.5733L25.0046 56.2978L22.4371 36.0221L42.3682 31.5L53.4344 14.3176Z"
                              fill="#888888"
                            />
                            <path
                              d="M55.1372 20.3457L71.2632 28.6392L88.5843 23.2719L95.6065 39.9907L112.325 47.0129L106.958 64.334L115.252 80.46L100.006 90.2787L95.9938 107.963L78.0038 105.685L63.563 116.653L51.2461 103.344L33.1339 102.463L32.2533 84.3511L18.9445 72.0342L29.9123 57.5934L27.6343 39.6034L45.3185 35.5911L55.1372 20.3457Z"
                              fill="#C4C4C4"
                            />
                            <path
                              d="M85.5939 83.0302C85.7623 83.1986 85.8959 83.3985 85.987 83.6185C86.0782 83.8386 86.1251 84.0744 86.1251 84.3125C86.1251 84.5507 86.0782 84.7865 85.987 85.0065C85.8959 85.2266 85.7623 85.4265 85.5939 85.5949C85.4255 85.7633 85.2256 85.8969 85.0056 85.988C84.7855 86.0791 84.5497 86.126 84.3116 86.126C84.0734 86.126 83.8376 86.0791 83.6176 85.988C83.3975 85.8969 83.1976 85.7633 83.0292 85.5949L67.9991 70.5625L52.9689 85.5949C52.6288 85.935 52.1675 86.126 51.6866 86.126C51.2056 86.126 50.7443 85.935 50.4042 85.5949C50.0641 85.2548 49.873 84.7935 49.873 84.3125C49.873 83.8316 50.0641 83.3703 50.4042 83.0302L65.4366 68L50.4042 52.9699C50.0641 52.6298 49.873 52.1685 49.873 51.6875C49.873 51.2066 50.0641 50.7453 50.4042 50.4052C50.7443 50.0651 51.2056 49.874 51.6866 49.874C52.1675 49.874 52.6288 50.0651 52.9689 50.4052L67.9991 65.4376L83.0292 50.4052C83.3693 50.0651 83.8306 49.874 84.3116 49.874C84.7925 49.874 85.2538 50.0651 85.5939 50.4052C85.934 50.7453 86.1251 51.2066 86.1251 51.6875C86.1251 52.1685 85.934 52.6298 85.5939 52.9699L70.5615 68L85.5939 83.0302Z"
                              fill="white"
                            />
                          </svg>
                          <p className="text-[15px] font-[400] text-[#000000] text-center">
                            This Loan does not require guarantors
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {activeTab === "tab4" && (
                  <div>
                    {approvals?.length > 0 ? (
                      <div className="flex gap-8 mt-6">
                        <div className="flex-1">
                          <h3 className="text-lg font-semibold text-black mb-2">
                            User ID
                          </h3>
                          {approvals?.map((approval, index) => (
                            <p key={index} className="text-gray-700">
                              {approval.admin?.public_id || "N/A"}
                            </p>
                          ))}
                        </div>
                        <div className="flex-1">
                          <h3 className="text-lg font-semibold text-black mb-2">
                            Name
                          </h3>
                          {approvals.map((approval, index) => (
                            <p key={index} className="text-gray-700">
                              {approval.admin
                                ? `${approval.admin.firstname} ${approval.admin.lastname}`
                                : "No Admin"}
                            </p>
                          ))}
                        </div>
                        <div className="flex-1">
                          <h3 className="text-lg font-semibold text-black mb-2">
                            Approval Time
                          </h3>
                          {approvals.map((approval, index) => (
                            <p key={index} className="text-gray-700">
                              {new Date(approval.createdAt).toLocaleString()}
                            </p>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <p className="text-gray-500 mt-4">
                        No approval records for this loan found.
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="flex items-center justify-between w-full h-[15vh] px-5 py-4 border-t border-gray-200 bg-white">
              <button
                type="button"
                onClick={declineDisbursment}
                className="text-[#FF5757] font-[500] rounded-[5px] text-[16px] px-8 py-2 text-center border border-[#FF5757]"
              >
                Decline Disbursement
              </button>

              <button
                onClick={handleDisburseLoan}
                type="button"
                className="text-white bg-[#005C53] hover:bg-[#005C53] focus:outline-none block rounded-[5px] text-[16px] font-[500] px-8 py-2.5 text-center"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrepareLoanDisbursement;
